angular.module('impactx.invoice').directive('ixInvoiceAddress', function ()
{
    return {
        scope: {
            address : "=",
            headerLabel: "@",
            requiredLabel: "@",
            dialogData: "=",
            name: "@",
            contactLabel: "@",
            contact: "=",
            companyPopup: "=",
            changeableCompany: "=",
            readOnly: "=",
            forCreator: "=",
            forGoodsReceiver: "=",
            forInvoiceReceiver: "=",
            goodsReceiverAddressDifferent: "=",
            goodsReceiverContactDifferent: "=",
            new: "=",
            dispatchData: "=",
            supplierCompany: "=",
            invoiceTrns:"=",
            invoiceReceiverId: "="
        },
        restrict: 'E',
        templateUrl: 'modules/invoice/templates/invoiceaddress.template.html',
        controller: 'InvoiceAddressCtrl',
        controllerAs: 'invoiceAddressCtrl',
        transclude: true
    };
});